import React, { Suspense } from 'react';
import { FaRegListAlt } from 'react-icons/fa';
import { Card, Tabs, LoadingSpinner } from 'components/common';
import PeriodHeader from './period/PeriodHeader';
import { useAgGrid } from 'hooks/useAgGrid';
import { getPeriods } from 'redux/erp/periodSlice';

const LazyPeriodList = React.lazy(() => import('./period/PeriodList'));

const Periods = () => {
  const {
    gridRef,
    gridApi,
    onGridReady,
    refreshGrid,
    updateRow,
    addRow,
    removeRow,
    clearAll,
    currentParams,
    updateCustomParams
  } = useAgGrid(getPeriods);

  return (
    <>
      <PeriodHeader
        currentParams={currentParams}
        refreshGrid={refreshGrid}
        clearFilter={clearAll}
        addRow={addRow}
      />

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={[
            {
              label: 'All',
              icon: <FaRegListAlt size={13} />,
              content: (
                <Suspense fallback={<LoadingSpinner message="Loading..." />}>
                  <LazyPeriodList
                    gridRef={gridRef}
                    gridApi={gridApi}
                    onGridReady={onGridReady}
                    addRow={addRow}
                    updateRow={updateRow}
                    removeRow={removeRow}
                    clearAll={clearAll}
                    refreshGrid={refreshGrid}
                    currentParams={currentParams}
                    updateCustomParams={updateCustomParams}
                  />
                </Suspense>
              ),
            },
          ]}
        />
      </Card>
    </>
  )
}

export default Periods;
